import { render, staticRenderFns } from "./CommodityFLowStateDetail.vue?vue&type=template&id=9a7d7cce&scoped=true&"
import script from "./CommodityFLowStateDetail.vue?vue&type=script&lang=js&"
export * from "./CommodityFLowStateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7d7cce",
  null
  
)

export default component.exports